import React, {FC} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, KTSVG, toAbsoluteUrl, WithChildren} from '../../../helpers'
import {useLayout} from '../../core'
import {Card, Row} from 'react-bootstrap'

type Props = {
  to: string
  title: string
  className?: string
  column?: 4 | 6 | 12
  biIcon?: string
  dtIcon?: string
  faIcon?: string
  image?: string
  variant: string
  width?: number
  widthLg?: number
}

const AsideMenuItemWithSub: FC<Props & WithChildren> = ({to, title, className, column, biIcon, dtIcon, faIcon, image, variant, width, widthLg, children}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  const {aside} = config

  if (column == undefined && width == undefined ) 
    width = 90
  else if (width == undefined)
    width = 150

  if (column == undefined && widthLg == undefined ) 
    widthLg = 125
  else if (widthLg == undefined)
    widthLg = 175
  
  return (
    <div className={column && `col-${column}`}>
      <div
        className={clsx(
          `btn btn-icon text-active-${variant} text-hover-${variant} btn-flex flex-column flex-center ${className ?? ''}
           ${column == undefined ? 'btn-bg-light btn-active-white' : `h-100 w-100 px-3 py-4 btn-bg-white btn-active-light-${variant}`}`,
          {
            active: isActive,
          }
        )}
        data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
        data-kt-menu-placement='right-start'
      >
        {biIcon && aside.menuIcon === 'font' && <i className={clsx('fs-1 my-2', biIcon)}></i>}
        {dtIcon && aside.menuIcon === 'svg' && <KTSVG path={dtIcon} className='svg-icon-2 my-1 my-lg-2' />}
        {faIcon && aside.menuIcon === 'font' && <i className={clsx('fs-1 my-1 my-lg-2', faIcon)}></i>}
        {image && <img className='h-30px my-2' src={toAbsoluteUrl(image)} style={{filter: 'grayscale(1) opacity(0.9)'}} />}
        <span
          className={clsx('fs-9 fs-lg-7 lh-sm d-lg-block pt-1', {
            'fw-normal': !isActive,
            'fw-bold': isActive,
          })}
        >
          {title}
        </span>
      </div>
      <div className={`menu menu-sub menu-sub-dropdown menu-column ${'w-' + width + 'px w-lg-' + widthLg + 'px'} `} data-kt-menu='true'>
        <Card>
          <Card.Body className='p-4'>
            <div className='mh-300px scroll-y me-n1 pe-1'>
              <Row className='gx-2 gy-5'>{children}</Row>
            </div>
          </Card.Body>
        </Card>
      </div>
    </div>
  )
}

export {AsideMenuItemWithSub}
